<app-kp-results-header
  [type]="type()"
  [stateKey]="stateKey()"
  [listState]="listStateService.state"
  [count]="resultCount()"
  [disabled]="controlsDisabled()"
  (typeChange)="handleTypeChange($event)"
>
  <!-- Sort & filter (stitch-app-shell skin): the filter icon at the row's end; the sort it shows is in its name. -->
  <app-button2
    appearance="secondary"
    size="m"
    [ariaLabel]="'Sort & filter: ' + sortLabel()"
    [matTooltip]="'Sort: ' + sortLabel()"
    appMessagesListContextMenu
    [appMessagesListContextMenuWithScore]="true"
    [appMessagesListContextMenuWithToSort]="true"
    [appMessagesListContextMenuWithFromSort]="true"
    [class]="sortActive() ? 'kp-sort-button [&>button]:border-primary-600 [&>button]:text-primary-600' : 'kp-sort-button'"
    [disabled]="controlsDisabled()"
    [stchPopoverDisabled]="controlsDisabled()"
    (contextMenuOpened)="sortMenuOpened.set($event)"
  >
    <app-icon class="shrink-0" name="filters" [size]="20" />
  </app-button2>
</app-kp-results-header>
<div class="list flex flex-col">
  <app-messages2-list
    variant="card"
    cardSelection="position"
    [compactCard]="true"
    [archiveTrashEnabled]="false"
    [showLocationBadge]="true"
    [filters]="state"
    [tenantItems]="contextTenantItems()"
    [withTags]="withTags()"
    [withKnots]="withKnots()"
    [withConnections]="withConnections()"
    [knotsSource]="knotsSource"
    [notFoundTemplate]="resultsEmpty"
    (totalCountChange)="resultCount.set($event)"
    (openMessage)="handleClickItem($event.id)"
    (clickMessage)="handleClickItem($event.id)"
    (doubleClickMessage)="handleDoubleClickItem($event.id)"
  />
</div>
<ng-template #resultsEmpty>
  <app-kp-results-empty [state]="emptyState()" [type]="type()" />
</ng-template>
